/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="6.34"
        height="11"
        viewBox="0 0 6.34 11"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M.37.22A1,1,0,0,1,1.69.28l.09.09L6.34,6,1.71,10.7a1,1,0,0,1-1.41,0A1,1,0,0,1,.2,9.4l.08-.1L3.66,5.85.22,1.63A1,1,0,0,1,.28.31Z"
          transform="translate(0 0)"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'CaratRightIcon';

export default Icon;
